<form [formGroup]="formGroup">
  <div class="auth-container p-2">
    <div class="login-box">
      <div class="surface-card p-4 shadow-2 border-round-2xl w-full">

        <div class="flex justify-content-center">
          <div class="text-center mb-5 mt-3">
            <img src="../../../../assets/images/logo_klaus_light_blue.svg"
                 class="w-10rem" alt="logo" (click)="navigateToLogin()">
          </div>
        </div>

        <div class="text-center mb-4">
          <div class="text-color text-3xl font-semibold mb-2">Telefonnummer eingeben</div>
          <span class="text-600 font-medium line-height-3 text-color-secondary">Trag deine Telefonnummer ein und erhalte dein Einmalpasswort per SMS.</span>
        </div>

        <div class="mb-2">
          <label class="block text-900 font-medium mb-2">Telefonnummer</label>
          <span class="p-input-icon-left block">
            <i class="flex gap-2 text-primary line-height-1 font-medium" style="font-style: normal;">
              <div class="flag-container">
              <div class="stripe black"></div>
              <div class="stripe red"></div>
              <div class="stripe gold"></div>
              </div>+49</i>
            <p-inputNumber
              class="block"
              styleClass="block"
              [inputStyle]="{'padding-left': '6rem', width: '100%'}"
              [format]="false"
              placeholder="Deine Nummer"
              formControlName="phone"
              [maxlength]="14"
            />
          </span>
        </div>
        <!-- Validation Message -->
        <p-message
          severity="error"
          text="Bitte gib eine gültige Telefonnummer ein."
          *ngIf="formGroup?.get('phone')?.invalid  && showValidation">
        </p-message>

        <app-button
          [type]="'submit'"
          [busy]="busy"
          [label]="'Weiter'"
          [class]="'w-full my-2'"
          (click)="handleStepComplete()">
        </app-button>
        <div class="flex justify-content-center">
          <app-button
            [label]="'Andere Option wählen'"
            [class]="'p-button-text mt-2'"
            [showIcon]="true"
            [iconPos]="'left'"
            [icon]="'pi pi-arrow-left'"
            (onClick)="navigateBack()">
          </app-button>
        </div>
      </div>
    </div>
  </div>
</form>
